import { render, staticRenderFns } from "./PlatformUploadHistory.vue?vue&type=template&id=6fbee9f0&"
import script from "./PlatformUploadHistory.vue?vue&type=script&lang=js&"
export * from "./PlatformUploadHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports